import React, { useCallback, useState } from "react";
import Modal from "./modal";
import { useTranslation } from "react-i18next";

// Assets
import star1 from "./assets/star1.svg";
import star2 from "./assets/star2.svg";
//import ProcessingMascot from "./assets/processing_mascot.png";
import Logo from "./assets/logo.png";

// Styles
import styles from "./processingModal.module.css";
import { ReactComponent as CloseIcon } from 'images/close-stroke.svg';


interface ProcessingModalProps {
  open: boolean;
  message?: string;
  back_url?: string;
}

const ProcessingModal: React.FC<ProcessingModalProps> = ({ open, message, back_url }) => {
  const { t } = useTranslation();
  const [logoLoaded, setLogoLoaded] = useState(false);

  const handleClose = useCallback(() => {
    Turbo.visit(back_url || '/');
  }, [back_url]);

  return (
    <Modal open={open} className={styles.modal} onClose={handleClose}>
      <button
          onClick={handleClose}
          className="absolute top-6 end-6 flex justify-center items-center rounded-full bg-stone-50 hover:opacity-80 dark:bg-zeus-800 dark:hover:bg-zeus-900 h-8 w-8 z-10"
          type="button"
        >
          <CloseIcon className="w-[10px] h-[10px] fill-stone-700 dark:text-white stroke-3" />
        </button>
      <img src={star1} alt="Start 1" className={`${styles.star1} dark:hidden`} />
      <img src={star2} alt="Star 2" className={`${styles.star2} dark:hidden`} />

      <div className={styles.content}>
        <h1 className={`${styles.title} dark:text-white`}>
          {t('processingModal.title')}
        </h1>
        <img
          src={Logo}
          alt="Processing Logo"
          className={`${styles.mascot} ${logoLoaded ? styles.mascotVisible : styles.mascotHidden}`}
          onLoad={() => setLogoLoaded(true)}
          loading="eager"
          decoding="async"
        />
        <p className={styles.description}>{t('processingModal.description')}</p>
      </div>
    </Modal>
  )
}

export default ProcessingModal;
